<app-data-table [configuration]="tableConfiguration"></app-data-table>
<div class="mt-2 caption">
  Number of required samples: {{ requiredSamples$ | async }}
</div>
